import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";
import axios from 'axios'

const data = {};

const settingSlice = createSlice({
name:'setting', 
initialState:{ 
    loading: false,
    setting :data,
    sendType:"AI",
    activities:[],
    activity:{},
    candidates:[]
},
reducers:{
    set_setting:(state,action)=>{
        state.setting = action.payload;
    },
    set_sendType:(state,action)=>{
        state.sendType = action.payload;
    },
    del_setting:(state)=>{
        state.setting = data
    },
    add_activities:(state,action)=>{
        state.activities = action.payload
    },
    add_activity:(state,action)=>{
        state.activity = action.payload
    },
    add_candidates:(state,action)=>{
        state.candidates = action.payload
    },
    delete_candidates:(state)=>{
        state.candidates = []
    }
}
})

export const {set_setting,del_setting,add_activities,set_sendType,add_activity,add_candidates,delete_candidates} = settingSlice.actions;
export default settingSlice.reducer;